import React from "react";
import "./styles.scss";
import UserTag from "../../shared/UserTag";
import { Link } from "react-router-dom";
import { filterTimeStamp } from "../../../../api/helper";
import get from 'lodash/get';

const parse_target = (notification) => {
  const t = get(notification, "target");
  const s = get(notification, "source");
  const formattedText = get(notification, "formatted_text");
  
  switch (t && t.type) {
    case "Like":
      let link;
      const likeableType = t.likeable_type.toLowerCase();
      if (["podcast", "playlist"].includes(likeableType)) {
        link = `/${s.slug}/${likeableType}s/${t.likeable_id}`;
      } else {
        const likeableTypeLink =
          likeableType === "soundtrack" ? "sound_track" : likeableType;
        link = `/${likeableTypeLink}/${t.likeable_id}`;
      }
      return (
        <Link to={link}>
          {formattedText.includes('episode') ? "podcast episode" : likeableType === "soundtrack" ? "track" : likeableType}
        </Link>
      );
    case "Post":
      const link_txt = "Tap to check it out!"
      return (
        <Link to={`/${t.author.slug}`}>
          {link_txt}
        </Link>
      );
    case "Comment":
      return (
        <Link to={`/${t.commentable_type.toLowerCase()}/${t.commentable_id}`}>
          {t.commentable_type.toLowerCase()}
        </Link>
      );
    case "PostAttachment":
      return (
        <Link to={`/${t.attachable_type.toLowerCase()}/${t.attachable_id}`}>
          {t.attachable_type.toLowerCase()}
        </Link>
      );
    case "Followship":
      return "you";
    default:
      return null;
  }
};

export default ({ notification }) => (
  <div className="notification d-flex usertag">
    <UserTag user={notification.source} />
    <label className="my-0 ml-1">{notification.action}</label>
    <label className="my-0 ml-1">
      {parse_target(notification)}
    </label>
    <small className="ml-1">{filterTimeStamp(notification.created_at)}</small>
  </div>
);
